export enum CUSTOMER_STATUS {
  ACTIVE = 'A',
  BLOCKED = 'B',
}

export type AddressData = [string, string, string];

export interface Customers {
  customerId: string;
  agentId: string;
  customerInfo: string;
  emailAddress: string;
  mobileNumber: number;
  rewardPoints: number;
  referrer: string;
  status: CUSTOMER_STATUS.ACTIVE | CUSTOMER_STATUS.BLOCKED;
  createdDate: string;
  updatedDate: string;
}

export interface CustomersDetails {
  customerId: string;
  username: string;
  lastName: string;
  firstName: string;
  emailAddress: string;
  mobileNumber: string;
  gender: 'M' | 'F' | 'O';
  postalCode: string;
  prefecture: string;
  city: string;
  street: string;
  residenceNumber: string;
  rewardPoints: number;
  dob: number;
  image: {
    alt: string;
    description: string;
    path: string;
  };
  customerNameFurigana: string;
  buildingNo: string;
  profileImage: string | File;
}

export interface CustomersListParams {
  row?: number;
  fetch?: number;
  search?: string;
  fromDate?: number;
  toDate?: number;
  createdDate?: number;
}

export interface CustomersParams {
  page?: number;
  fetch?: number;
  q?: string;
  createdDate?: {
    start: number;
    end: number;
  };
}
